<template>
  <div>
    <v-img :src="img" class="img">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-btn color="#0D296E" dark rounded x-large class="btn" @click="goToLogin()">
            بازگشت به صفحه اصلی
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-img>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        img: require('../assets/images/401.png'),
      };
    },
    methods: {
      goToLogin: function () {
        this.$router.push({ name: 'login' });
      },
    },
  };
</script>
<style scoped>
  .img {
    position: absolute;
    width: 100% !important;
    height: 100%;
    right: 0%;
  }
  .btn {
    letter-spacing: normal;
    position: absolute;
    bottom: 9%;
    right: 43.7%;
  }
</style>
